import { IsBoolean, IsEnum, IsNotEmpty, IsObject, IsOptional, IsString } from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { NotificationId, UserId } from '../../types';

export enum NotificationType {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SYSTEM = 'SYSTEM',
}

export class NotificationDto extends BaseDto<NotificationId> {
  @IsString()
  @IsNotEmpty()
  userId!: UserId;

  @IsString()
  @IsNotEmpty()
  title!: string;

  @IsString()
  @IsNotEmpty()
  message!: string;

  @IsEnum(NotificationType)
  @IsNotEmpty()
  type!: NotificationType;

  @IsBoolean()
  @IsNotEmpty()
  read!: boolean;

  @IsObject()
  @IsOptional()
  metadata?: Record<string, unknown>;
}

export class CreateNotificationDto {
  @IsString()
  @IsNotEmpty()
  userId!: UserId;

  @IsString()
  @IsNotEmpty()
  title!: string;

  @IsString()
  @IsNotEmpty()
  message!: string;

  @IsEnum(NotificationType)
  @IsOptional()
  type?: NotificationType;

  @IsObject()
  @IsOptional()
  metadata?: Record<string, unknown>;
}
